<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <thead>
                            <tr>
                                <th>Désignation</th>
                                <th class="text-center" style="width: 120px;">Quantité</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(article, index) in articles" v-if="!loading">
                            <td>
                                {{ article.name }}
                                <input type="hidden" :name="'articles[' + index + '][id]'" v-model="article.id">
                                <input type="hidden" :name="'articles[' + index + '][name]'" v-model="article.name">
                            </td>
                            <td>
                                <input type="number" class="form-control form-control-sm text-center" :name="'articles[' + index + '][quantity]'" v-model="article.quantity" required step="0.001" min="0" :id="'quantity' + index">
                            </td>
                            <td class="text-right">
                                <button type="button" class="btn btn-sm transparent" @click="deleteRow(index)">
                                    <i class="far fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="loading">
                            <td colspan="2" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                        <tr v-show="!loading">
                            <td colspan="100%">
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." onkeydown="return event.key != 'Enter';" class="form-control" id="articleSearchInput" type="text" v-model="article">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        name: 'article-seletor',
        props: ['route', 'oldArticles', 'exclude'],
        data() {
            return {
                loading: true,
                article: null,
                articles: []
            };
        },
        methods : {
            addRow: function (article, focus = false) {
                if (this.getCurrentSelectedArticlesId().includes(article.id) == false && (this.exclude == undefined || (this.exclude != undefined && this.exclude != article.id))) {
                    this.articles.push({
                        id: article.id,
                        name: article.name,
                        quantity: article.quantity ? article.quantity : '',
                    })

                    if (focus == true) {
                        setTimeout(() => {
                            $('#quantity' + (this.articles.length - 1)).focus();
                        }, 250)
                    }
                }
            },
            deleteRow: function (index) {
                this.articles.splice(index, 1)
            },
            getCurrentSelectedArticlesId: function() {
                return this.articles.map(article => article.id);
            }
        },
        mounted(){
            $("#articleSearchInput").autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.route,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedArticlesId().join(';') + (this.exclude != undefined ? (';' + this.exclude) : '') },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name,
                                    number: item.number,
                                    reference: item.reference
                                })
                            }))
                        }
                    });
                },
                 create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var number = item.number ? item.number : 'Non renseigné'; 
                        var html = `<div class="d-flex align-items-center">
                                      <span class="badge badge-secondary">${number}</span>
                                      <span class="ml-2">${item.name}</span>`;

                        if(item.reference){
                             html += `<span class="ml-auto">${item.reference}</span>
                                    </div>`
                        }
                       

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.article = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addRow(item.item, true)

                        $(e.target).val("")
                        this.article = null
                    }
                }
            }).focus(() => {
                $("#articleSearchInput").autocomplete("search", '');
            });

            const jsonArticleBackup = JSON.parse(this.oldArticles)
            if (Array.isArray(jsonArticleBackup)) {
                if (jsonArticleBackup.length > 0) {
                    jsonArticleBackup.forEach(article => {
                        this.addRow(article)
                    })
                }
            }
            this.loading = false
        }
    }
</script>
